import { defineStore } from 'pinia'

const usePausaStore = defineStore('pausa', {
  state: () => ({
    id: null,
    nome: '',
    tempo: 0,
    bloquearTela: false,

    horarioMarcacao: null,
    timer: 0,
    timerInterval: null,
  }),

  actions: {
    setId(value) {
      this.id = value
    },
    setNome(value) {
      this.nome = value
    },
    setTempo(value) {
      this.tempo = value
    },
    setBloquearTela(value) {
      this.bloquearTela = value
    },
    setHorarioMarcacao(value) {
      this.horarioMarcacao = value
    },
    setTimer(value) {
      this.timer = value
    },
    setTimerInterval(value) {
      this.timerInterval = value
    },
  },

  persist: true,
})

export default usePausaStore
